import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getNc, getPid } from '../utils/utils';

const RedirectToOCR = () => {
  const navigate = useNavigate();
  const { search, pathname } = useLocation();

  useEffect(() => {
    const pid = getPid(search);
    const nc = getNc(search);
    const pathAfterOCR = pathname.replace(/^\/ocr/, '');
    navigate(
      `/app/project/${pid}/quality/ocr${pathAfterOCR}${nc ? `?nc=${nc}` : ''}`,
    );
  }, [navigate, pathname, search]);

  return null;
};

export default RedirectToOCR;
